export default "__VITE_ASSET__CahcHlzN__"